import React from 'react'
import axios from 'axios'
import Spinner from '~/components/Spinner'
import popup from '../../popup'
import './verifyotp.css'
import Cookies from 'js-cookie'
import userStore from '~/redux/user/store'
import {signup, login, getCardInfo, refresh, setParentalControls, updatePin, otpVerify} from '~/redux/user/actions'
import { get} from 'lodash'
import { addUserProfile, trackEvent } from '~/tools/analytics/cleverTap'
import { async } from 'q';
import { refreshUser} from '~/redux/user/helpers'

export default class View extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
        isResendDisabled:true,
        itemCounter:15,
        pinSetupSuccess: false,
        processing: false
    }
   
    this.userObject=this.props.args;
    this.metaDataMap=this.userObject.metaDataMap;
    this.timeCount=15;
  }

  componentDidMount() {
    this.startResendTimer();
  }

  startResendTimer = ()=>{
    this.intervalTimer = setInterval(()=>{
      if(this.state.itemCounter==0){
        clearInterval(this.intervalTimer);
        this.setState(prevState => ({ 
          itemCounter:0,   
          isResendDisabled: false,
          error: this.getVal('NOT_RECEIVED_OTP')
        }));
      }else{
        this.setState(prevState => ({  
          itemCounter: prevState.itemCounter-1,
          isResendDisabled: true,
        }));
      }
    }, 1000);
  }


  resentTheOtp = async(phoneNumber)=>{
    this.phoneCodeOne.value="";
    this.phoneCodeTwo.value="";
    this.phoneCodeThree.value="";
    this.phoneCodeFour.value="";

    this.setState(prevState => ({    
      isResendDisabled: true,
    }));

    await axios({
      method: 'POST',
      url: `${window.settings.apiBaseUrl}/identity/otp/resend`,
      params: {
        site: window.settings.internalName
      },
      data: {phoneNumber},
      headers: {
        'x-api-key': window.settings.baseAPIKey
      }
    }).then( res => {
      let message="OTP IS SENT AGAIN SUCCESSFULLY";
      this.setState(prevState => ({    
        itemCounter: 15,
        isResendDisabled: true,
        error: message
      }));
      this.startResendTimer();
    }).catch(error=>{
      let message=error.response && error.response.data && error.response.data.error;
      this.setState(prevState => ({    
        isResendDisabled: false,
      }));
      this.alert(message)
    })
  }

  getVal(key){
    return get(this.metaDataMap, key)
  }

  sendCleverTapEvents(userInfo, isSignup){
    userInfo && addUserProfile('Site', {
      'Name': userInfo.name,
      'Email': userInfo.email,
      'Identity': userInfo.userId,
      'User Status': userInfo.isSubscribed ? 'Subscribed' : 'Registered and Never Subscribed',
    })

    if(isSignup)
      trackEvent('Signed Up', {registrationType: 'Native',platform:'Web'})
    else
      trackEvent('Login', {platform: 'Web', registrationType: 'Native'})
  }

  submitOTP= async(event, otpValue)=>{ 
    event.preventDefault();  
    let userPhoneObject={}
    userPhoneObject['requestType']="verify";
    userPhoneObject['otpValue']=otpValue;
    userPhoneObject['phoneNumber']=this.userObject && this.userObject.phoneNumber;

    if(this.userObject["screenName"] == "signin") {
      if(this.props.onInitiate){ this.props.onInitiate('login') }
      userStore
      .dispatch(login(userPhoneObject))
      .then( _ => {
        var userInfo = userStore.getState().user || {}
        userInfo && addUserProfile("Site", {
          Name: userInfo.name,
          Email: userInfo.email,
          Identity: userInfo.userId,
          Phone: userInfo.phoneNumber ? userInfo.phoneNumber : '',
          phone_number: userInfo.phoneNumber ? userInfo.phoneNumber : '',
          "User Status": userInfo.isSubscribed
            ? "Subscribed"
            : "Registered and Never Subscribed"
        });
        let loginType='Native';
        trackEvent('Login', {platform: 'Web', registrationType: loginType})
        userStore
          .dispatch(getCardInfo(userInfo))
          .then(res => {
            if (this.props.onAuthenticate) {
              this.props.onAuthenticate(true)
              return false
            } else if (!_.value.isSubscribed && window.settings.serviceType === "SVOD") {
              if(this.props.args === "FREE" || this.props.args === "AVOD")  {
                window.location.reload();
                return false;
              }    
              window.location.href = "/viewplans";
              return false;
            } else if(window.settings.serviceType === "AVOD") {
              window.location.reload()
              return false;
            }
          });
        this.setState({ buttonProgress: false })
        popup.hide()     
      })
      .then(res => {
        userStore
        .dispatch(refresh())
      })
      .catch( error => {
        var errorCode = ""
        this.setState({ buttonProgress: false })
        if(error.response && error.response.data) {
          errorCode = error.response.data.code
        }
        var message = this.getVal( (((error || {}).response || {}).data || {}).code) || this.getVal('defaultError')
        this.alert(message)
        if(this.props.onAuthenticate){ this.props.onAuthenticate(false, message) }
      })
    }

    if(this.userObject["screenName"]=="update"){
      const userInfo = JSON.parse(localStorage.getItem('user'));
      var updateParams = {
        site: window.settings.internalName,
        userId: userInfo && userInfo.user && userInfo.user.userId
      }
      await axios({
        method: 'POST',
        url: `${window.settings.apiBaseUrl}/identity/user/updatePhone`,
        params: updateParams,
        data: userPhoneObject,
        headers: {
          'x-api-key': window.settings.baseAPIKey
        }
      }).then( async (res) => {
        userPhoneObject["screenName"]="update"
        await refreshUser();
        var userInfo = userStore.getState().user || {};
        userInfo && addUserProfile('Site', {
          'Name': userInfo.name,
          'Email': userInfo.email,
          'Identity': userInfo.userId,
          'Phone': this.userObject && this.userObject.phoneNumber,
          'phone_number': this.userObject && this.userObject.phoneNumber,
          'User Status': userInfo.isSubscribed ? 'Subscribed' : 'Registered and Never Subscribed',
        })
        window.location.reload();
        popup.hide();
      }).catch(error=>{
          this.setState({...this.state, buttonProgress: false })
        var message =
          this.getVal((((error || {}).response || {}).data || {}).code) || this.getVal('defaultError')
        this.alert(message)
        if(this.props.onAuthenticate){ this.props.onAuthenticate(false, message) }
      })
    }

    if(this.userObject["screenName"]=="signup" || this.userObject["screenName"]=="subscription"){
        let userPhoneObject={}
        
        userPhoneObject['requestType']="verify";
        userPhoneObject['otpValue']=otpValue;
        userPhoneObject['phoneNumber']=this.userObject && this.userObject.phoneNumber;
        if(this.userObject.email)
          userPhoneObject['email']=this.userObject && this.userObject.email;

        userStore
        .dispatch(signup(userPhoneObject))
        .then( _ => {
            var userInfo = userStore.getState().user || {};
            userInfo && addUserProfile('Site', {
              'Name': userInfo.name,
              'Email': userInfo.email,
              'Identity': userInfo.userId,
              'Phone': userInfo.phoneNumber ? userInfo.phoneNumber : '',
              'phone_number': userInfo.phoneNumber ? userInfo.phoneNumber : '',
              'User Status': userInfo.isSubscribed ? 'Subscribed' : 'Registered and Never Subscribed',
            })
            trackEvent('Signed Up', {registrationType: 'Native',platform:'Web'})
            //The User has successfully Signed Up and we need to save this to open personalization screen when succesfully sign up
            Cookies.set('isUserSignUp', true)
            
            if(this.props.onAuthenticate){ 
              this.props.onAuthenticate(true) 
              return false
            } 
            //As This is coming from OTP Flow. No Need to Refresh and open the popup and open phone number screen.
            //window.location.href="/viewplans";
            if(this.userObject["screenName"]=="subscription"){
              const subscriptionInfoId=this.userObject["planId"];
              popup.hide();
              if(subscriptionInfoId){
                popup.createSubscription(subscriptionInfoId);
                return;
              }
            }else{
              window.location.href="/viewplans";
            }
            this.setState({ buttonProgress: false })
            popup.hide()   
          })
          .catch(error => {
            this.setState({ buttonProgress: false })
            var message = this.getVal( (((error || {}).response || {}).data || {}).code) || this.getVal('defaultError')
            this.alert(message)
            if(this.props.onAuthenticate){ this.props.onAuthenticate(false, message) }
          })
    }
    if (this.userObject["screenName"] === "parentalControl") {
      this.setState({processing: true})
      const parentalPin = { 'parentalPin': this.userObject['parentalPin'] }
      axios({
        method: 'POST',
        url: `${window.settings.apiBaseUrl}/identity/signin`,
        params: {
          site: window.settings.internalName
        },
        data: userPhoneObject,
        headers: {
          'x-api-key': window.settings.baseAPIKey
        },
      }).then((res) => {
        if(res && res.status === 200){
        userStore.dispatch(refresh()).then(() => {
          setParentalControls(parentalPin)
            .then(() => {
              userStore.dispatch(updatePin(this.userObject['parentalPin']))
                this.setState({ processing: false, pinSetupSuccess: true })
                popup.hide()
            })
        })
      }else {
        const message="Please enter correct OTP"
        this.alert(message)
        this.setState({processing: false})
      }}).catch(err =>{
        console.error(err)
        const message = "Please enter correct OTP"
        this.alert(message)
        this.setState({processing: false})
      })
    }
  }

  callBackCompleted=()=>{

  }

  startIntervalTimer = value => {
    return (
      <div className="timer">
        <div className="text">Remaining</div>
        <div className="value">{value}</div>
        <div className="text">seconds</div>
      </div>
    );
  };
  

  otpTextChange = (input)=>{
    let classValueInput=input.target.id;
    switch(classValueInput){
      case "input-one":
        this.phoneCodeTwo.focus();
        break;
      case "input-two":
        this.phoneCodeThree.focus();
        break;
      case "input-three":
        this.phoneCodeFour.focus();
        break;
      case "input-four":
        this.phoneCodeOne.focus();
        break;
      default:
        break;
    }
  }

  render() {
    const {phoneNumber} = this.userObject;

    // if(this.state.pinSetupSuccess === true) {
    //   return <div></div> ;
    // }

    return (
      <div className="auth-view centered">
        <img className="mobile-logo-image" src={ get(window.settings, 'images.desktopLogo') } alt="logo"/>
        <span className="site-border-color otp-sent-text">{`${this.getVal('verifyOTPText') || "Please enter 4 digit OTP sent to your number " } ${phoneNumber}`}</span>

        <div className="otp-input">
            <input id="input-one" className="single-otp-input" autoFocus type="text" onChange={this.otpTextChange} maxlength="1"  ref={ i => { this.phoneCodeOne = i} }  ></input>
            <input id="input-two"  className="single-otp-input " onChange={this.otpTextChange} type="text" maxlength="1" ref={ i => { this.phoneCodeTwo= i} } ></input>
            <input id="input-three" className="single-otp-input" onChange={this.otpTextChange} type="text" maxlength="1" ref={ i => { this.phoneCodeThree = i} } ></input>
            <input id="input-four" className="single-otp-input" onChange={this.otpTextChange} type="textt" maxlength="1" ref={ i => { this.phoneCodeFour = i} } ></input>
        </div>

        <div className={`submit-otp button fat cta` + (this.state.processing ? ' processing': '')} onClick={ e =>{ 
          let value = this.phoneCodeOne.value+this.phoneCodeTwo.value+this.phoneCodeThree.value+this.phoneCodeFour.value;
          this.submitOTP(e, value)
        }}>
            <span className="site-border-color">
              {this.getVal('verifyOTPSubmit') || "Submit OTP"}
            </span>
        </div>

        <div 
          disabled={this.state.isResendDisabled ? 'disabled' : null}
          className={`resend-otp button fat cta ${ this.state.isResendDisabled ? 'disabled' : '' }`}
          onClick={ e => this.resentTheOtp(phoneNumber) }>
            <span className="site-border-color" ref={ i => { this.resendOTPBox = i} }  >
              {this.state.itemCounter==0 ? this.getVal('resentOTPText') || "Resend OTP": this.state.itemCounter}
            </span>
        </div>

        <div className={ `error-box collapsible ${ this.state.error ? '' : 'collapsed' }` }>
            { this.state.error || '' }
        </div>

      </div>
    )
  }

  alert(txt) {
    this.setState({ error: txt })
  }
}